import { render, staticRenderFns } from "./pra.vue?vue&type=template&id=ad589aae&scoped=true&"
import script from "./pra.vue?vue&type=script&lang=js&"
export * from "./pra.vue?vue&type=script&lang=js&"
import style0 from "./pra.vue?vue&type=style&index=0&id=ad589aae&scoped=true&lang=less&"
import style1 from "./pra.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad589aae",
  null
  
)

export default component.exports